
const digest = '62546016a8326991513e6153d6085e08b5a23e73ec110d706c5c8e31783565cf';
const classes = {"wrapper":"_wrapper_1x40d_1","title":"_title_1x40d_7","controls":"_controls_1x40d_11"};
const css = `._wrapper_1x40d_1 {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
}
._wrapper_1x40d_1 ._title_1x40d_7 {
  flex-grow: 1;
  font-size: 14px;
}
._wrapper_1x40d_1 ._controls_1x40d_11 {
  display: flex;
  flex-direction: row;
  gap: 12px;
  min-width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  